// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AUTH_PARAMS } from "../configs/env.config";

const GW = {
  API: {
    rabbitAddress: "wss://svc.test.flexbet-software.com:14443:14443/ws4",
    turfGateway: "https://dmp.dme.systems/test_saloon_services",
    sportsGateway: "https://svc.test.flexbet-software.com:14443/sport-gateway/v2",
    imageServer: "https://media-bucket-spt.nyc3.digitaloceanspaces.com"
  }
}

export const environment = {
  production: false,
  staging: false,
  dev: true,
  ...GW,
  ...AUTH_PARAMS
};

export const RABBIT_CONFIG = {
  USER: "root",
  PASSWD: "admin",
  ACCUSER: "root",
  ACCPASSWD: "admin",
  EXCHANGE: "lonanionline",
  QUEUE: "flexbet.agent",
};

export const USER_RABBIT_CONFIG = {
  USER: "pmuweb_ws",
  PASSWD: "baY2CiG39SxR8flO",
  EXCHANGE: "betradarfeedsuof",
  QUEUE: "flexbet.agent.",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
